import { MenuItem } from "@mui/material";
import React, { useState } from "react";
import NextButton from "../../../components/buttons/NextButton";
import TextButton from "../../../components/buttons/TextButton";
import PhoneInput from "../../../components/inputs/PhoneInput";
import SelectInput from "../../../components/inputs/SelectInput";
import TextInput from "../../../components/inputs/text-input";
import ActionsFooter from "../../../components/layout/ActionsFooter";

const CompanyInfoStep = ({
  initialValues = {},
  onSubmit = () => {},
  onPrev = () => {},
}) => {
  const [companyName, setCompanyName] = useState(
    initialValues.companyName || ""
  );
  const [country, setCountry] = useState(initialValues.country || "BR");

  const [currency, setCurrency] = useState(initialValues.currency || "BRL");
  const [language, setLanguage] = useState(initialValues.language || "PT");
  const [usersNum, setUsersNum] = useState(initialValues.usersNum || "");
  const [erp, setErp] = useState(initialValues.erp || "");
  const [phone, setPhone] = useState(initialValues.phone || "");
  const [leadOrigin, setLeadOrigin] = useState(initialValues.leadOrigin || "");

  const [errors, setErrors] = useState({
    companyName: null,
    country: null,
    currency: null,
    language: null,
    phone: null,
    usersNum: null,
    erp: null,
    leadOrigin: null,
  });

  const setError = (field, value) => {
    setErrors((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const inavlidFiels = {
      companyName: !Boolean(companyName.trim()),
      country: !Boolean(country.trim()),
      currency: !Boolean(currency.trim()),
      language: !Boolean(language.trim()),
      erp: !Boolean(erp.trim()),
      leadOrigin: !Boolean(leadOrigin.trim()),
    };

    let ok = true;

    Object.keys(inavlidFiels).forEach((field) => {
      if (inavlidFiels[field]) {
        setError(field, "Campo obrigatório");
        ok = false;
      }
    });
    if (!ok) return;
    onSubmit({
      companyName,
      country,
      currency,
      language,
      phone,
      usersNum,
      erp,
      leadOrigin,
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <TextInput
        autoFocus
        value={companyName}
        onFocus={() => setError("companyName", null)}
        onChange={setCompanyName}
        margin={"normal"}
        label={"Nome da empresa"}
        helperText={errors.companyName || ""}
        error={Boolean(errors.companyName)}
        required
      />
      {/* <CountrySelect value={country} onChange={setCountry} />
      <SelectInput
        label="Moeda"
        value={currency}
        required
        onFocus={() => setError("currency", null)}
        onChange={setCurrency}
        helperText={errors.currency || ""}
        error={Boolean(errors.currency)}
      >
        <MenuItem value={"BRL"}>BRL (Real brasileiro)</MenuItem>
        <MenuItem value={"USD"}>USD (Dólar americano)</MenuItem>
        <MenuItem value={"EUR"}>EUR (Euro)</MenuItem>
      </SelectInput>
      <SelectInput
        label="Idioma"
        value={language}
        required
        onFocus={() => setError("language", null)}
        onChange={setLanguage}
        helperText={errors.language || ""}
        error={Boolean(errors.language)}
      >
        <MenuItem value={"PT"}>Português (Brasil)</MenuItem>
        <MenuItem value={"EN"}>Inglês (Estados Unidos)</MenuItem>
        <MenuItem value={"ES"}>Espanhol</MenuItem>
      </SelectInput> */}
      <SelectInput
        required
        label="Número de funcionários"
        value={usersNum}
        onChange={setUsersNum}
      >
        <MenuItem value={"1-50"}>1 - 50</MenuItem>
        <MenuItem value={"51-100"}>51 - 100</MenuItem>
        <MenuItem value={"101-200"}>101 - 200</MenuItem>
        <MenuItem value={"201-500"}>201 - 500</MenuItem>
        <MenuItem value={"+500"}>Mais de 500</MenuItem>
      </SelectInput>
      <SelectInput
        required
        label="Qual ERP sua empresa utiliza?"
        value={erp}
        onChange={setErp}
      >
        <MenuItem value={"Nenhum"}>Nenhum ERP</MenuItem>
        <MenuItem value={"SAP"}>SAP</MenuItem>
        <MenuItem value={"TOTVS"}>TOTVS</MenuItem>
        <MenuItem value={"Senior"}>Senior</MenuItem>
        <MenuItem value={"Outro"}>Outro</MenuItem>
      </SelectInput>
      <TextInput
        label={"Telefone"}
        margin={"normal"}
        value={phone}
        onChange={setPhone}
        type="tel"
        required
        inputComponent={PhoneInput}
      />
      <SelectInput
        required
        label="Como você nos encontrou?"
        value={leadOrigin}
        onChange={setLeadOrigin}
      >
        <MenuItem value={"Google / Pesquisa online"}>
          Google / Pesquisa online
        </MenuItem>
        <MenuItem value={"LinkedIn"}>LinkedIn</MenuItem>
        <MenuItem value={"Instagram"}>Instagram</MenuItem>
        <MenuItem value={"Indicação"}>Indicação de um amigo/empresa</MenuItem>
        <MenuItem value={"Outro"}>Outro</MenuItem>
      </SelectInput>
      <ActionsFooter
        rightContent={<NextButton />}
        leftContent={<TextButton onClick={onPrev}>Anterior</TextButton>}
      />
    </form>
  );
};

export default CompanyInfoStep;
